import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnNO: CultureInfo = {
  name: 'en-NO',
  displayName: 'English (Norway)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-NO',
  parent: CultureInfoEn
};
